module.exports = __webpack_public_path__ + "img/clover-orange.e6b07c85.png";